module.exports = __webpack_public_path__ + "52e5a389478167ae05e28ed23754a580.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/head/Impressum.jpg
// module id = 618
// module chunks = 0